import { EAvatarType } from '@NGUtils/enums';
import { getEnumFromValue } from '@NGUtils/functions';
import { axiosClient } from '@services/axios';
import { IUserPersonalData } from '@store/userStore/userStore.type';
import { SUPER_USERS } from '@utils/variables';

const getAndFormatLoginData = async (accessToken: string) => {
	const { data } = await axiosClient.get(
		process.env.REST_URL + `/auth/${process.env.STRAPI_AUTH_PROVIDER}/callback?access_token=${accessToken}`
	);

	if (!data?.jwt) throw new Error('Can not get authentication token');
	if (!data.user) throw new Error('Can not get user personal data');
	if (!data?.user?.id) throw new Error('Can not get user id');

	delete data.user.wallets.id;

	const avatarType = getEnumFromValue(data?.user?.avatarType, EAvatarType);

	const newUserPersonalData: IUserPersonalData = {
		userId: Number(data.user.id),
		jwt: data.jwt,
		notificationJwt: data.notificationJwt,
		username: data.user.displayedUsername,
		hash: data.user.hash,
		lastConnectionDate: data.user.lastConnectionDate,
		avatarType,
		wallets: data.user.wallets,
		githubId: data.user.githubId || null,
		isSuperUser: SUPER_USERS.includes(data.user.githubId || '')
	};

	return {
		...newUserPersonalData,
		githubAppState: data.githubAppInstalled
	};
};

export { getAndFormatLoginData };
